import * as React from "react";
const SvgUparrows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={4}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M1.355 3.572a.417.417 0 0 1-.542-.633l2.916-2.5a.417.417 0 0 1 .543 0l2.916 2.5a.417.417 0 1 1-.542.633L4.001 1.304 1.355 3.572Z"
    />
  </svg>
);
export default SvgUparrows;